import React, { useEffect, useState } from "react";
import styles from "./modal-left.module.css";
import { useDispatch } from "react-redux";
import { active, inactive } from "../../../../store/reducers/toggle/fullScreenArcpintToggle";
import { LOCALES, UI_TEXT } from "../../../../constants";
import { getUIText } from "../../../../translation";

export default function ModalLeft({ lang, savior }) {
    const [disabled, setDisabled] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        setDisabled(false);
        dispatch(inactive());
    }, [savior]);

    const openFullScreen = () => {
        if (!disabled) {
            setDisabled(true);
            return;
        }
        dispatch(active());
    };

    return (
        <div className={styles["modal-desc-left"]}>
            <div className={styles["illust-container"]}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/illust/${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]}).webp`}
                    alt="Savior Illustration"
                />
            </div>
            <div className={styles["arcpoint-container"]} onClick={() => openFullScreen()}>
                <h3>
                    {getUIText(lang, "savior.modal.arcpoint.title")}{" "}
                    <span className={styles["warning"]}>({getUIText(lang, "savior.modal.arcpoint.warning")})</span>
                </h3>
                <div className={`${styles["arcpoint-wrapper"]} ${disabled ? `${styles["disabled"]}` : ""}`}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/arcpoint/${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]}).webp`}
                        alt="Arc Point"
                    />
                    <div className={styles["overlay"]}>
                        <span>{getUIText(lang, "savior.modal.arcpoint.confirm")}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
